// CSV building + browser download for the trial-points report pages.

import moment from 'moment-timezone';
import { buildCsv, downloadCsv } from '../../../utils/csv';

export { buildCsv, downloadCsv };

// Consumed points are stored negative; flipped to match the teacher-wise CSV's positive Deducted.
const asMagnitude = (points) => (typeof points === 'number' ? Math.abs(points) : 0);

const CONVERSION_TYPE_LABELS = { conversion_1on1: '1on1', conversion_gc: 'GC' };

export const SESSION_CSV_HEADERS = [
  'Teacher UUID',
  'Teacher ID',
  'Teacher Name',
  'Email',
  'Session UUID',
  'Session Date',
  'Status',
  'Duration (mins)',
  'Student UUID',
  'Student Name',
  'Lead Score',
  'Deducted',
  'Refunded',
  'Conversion Points',
  'Conversion Type'
];

// Renders in the selected timezone; empty on first paint falls back to local rather than throwing.
const formatSessionDate = (sessionStart, ianaTimezone) => {
  if (!sessionStart) return '';
  const m = moment(sessionStart);
  return (ianaTimezone ? m.tz(ianaTimezone) : m).format('YYYY-MM-DD HH:mm z');
};

// Maps sessions_export rows into SESSION_CSV_HEADERS order. Pure, so the columns are testable.
export const buildSessionCsvRows = (rows, ianaTimezone) =>
  (rows || []).map((row) => [
    row.teacher_uuid || '',
    row.teacher_id ?? '',
    row.teacher_name || '',
    row.email || '',
    row.session_uuid || '',
    formatSessionDate(row.session_start, ianaTimezone),
    row.status_text || row.status || '',
    row.duration_minutes ?? '',
    row.student_uuid || '',
    row.student_name || '',
    // A missing score is unknown, a zero is real — they must not share a blank cell.
    row.lead_score ?? '',
    asMagnitude(row.points_consumed),
    asMagnitude(row.points_refunded),
    row.conversion_points ?? 0,
    CONVERSION_TYPE_LABELS[row.conversion_type] || ''
  ]);
